type RefuelDateSelectViewParams = {
  isError: boolean;
  hasSelectedDates: boolean;
  hasNoResult: boolean;
};

export type RefuelDateSelectView = 'error' | 'noResult' | 'dateRangePicker';

export function getRefuelDateSelectView({
  isError,
  hasSelectedDates,
  hasNoResult,
}: RefuelDateSelectViewParams): RefuelDateSelectView {
  if (isError) {
    return 'error';
  }

  if (hasSelectedDates && hasNoResult) {
    return 'noResult';
  }

  return 'dateRangePicker';
}
